<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'LogLabel',

    functional: true,

    props: {
        log: {type: Object, default: null},
        hideIcon: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            item: props.log,
            hideIcon: props.hideIcon,
            iconClass: 'fa fa-fw fa-history',
            none: parent.$t('logs.nil'),
        };

        return createElement(DataLabel, data);
    },
};
</script>
